import React from 'react';
import { MysticalButton } from './ui/MysticalButton';
export function CloseSection() {
  return <section className="relative py-12 md:py-32 bg-[#050a0f] text-center overflow-hidden" data-id="element-19">
      {/* Radial gradient background */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(201,168,76,0.05),transparent_70%)]" data-id="element-20" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-21">
        <h2 className="text-3xl md:text-5xl font-bold mb-5 md:mb-8 text-[#c8c0b0] max-w-4xl mx-auto leading-tight" data-id="element-22">
          You can stay as a background character in someone else's story...
        </h2>

        <p className="text-xl md:text-2xl text-[#c9a84c] mb-6 md:mb-12 font-serif italic" data-id="element-23">
          ...or you can wake up and start redesigning your own fractal.
        </p>

        <div className="max-w-xl mx-auto mb-6 md:mb-12" data-id="element-24">
          <p className="text-[#c8c0b0]/60" data-id="element-25">
            The veil is thinning. Which side do you want to be on when the
            illusion finally dissolves?
          </p>
        </div>

        <MysticalButton onClick={() => document.getElementById('offer')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-26">
          Break The Illusion Now
        </MysticalButton>
      </div>
    </section>;
}